module.exports = __webpack_public_path__ + "images/guidelines-mobile.jpg";